import { FormFieldsData } from 'framework/form';
import { useKernelApi } from 'infrastructure/api';

const useOpportunityDocumentService = () => {
  const { sendPostRequest } = useKernelApi();

  const commitDocuments = async (
    opportunityId: StringOrNumber,
    data: {
      paths: string[];
      metadata: {
        documentType: string;
        source?: string;
      };
    },
  ) => {
    const request = await sendPostRequest(`/crm/opportunities/${opportunityId}/documents/commit`, data);
    return request.json();
  };

  const searchDocuments = async (opportunityId: StringOrNumber, data: FormFieldsData) => {
    const request = await sendPostRequest(`/crm/opportunities/${opportunityId}/documents/search`, data);
    return request.json();
  };

  const getDocuments = async (opportunityId: StringOrNumber, paths: string[]) => {
    const request = await sendPostRequest(`/crm/opportunities/${opportunityId}/documents/files`, { paths });
    return request.json();
  };

  const generatePresignedLink = async (opportunityId: StringOrNumber, path: string) => {
    const request = await sendPostRequest(`/crm/opportunities/${opportunityId}/documents/download/link`, { path });
    return request.text();
  };

  const downloadFileContent = async (opportunityId: StringOrNumber, path: string) => {
    const request = await sendPostRequest(`/crm/opportunities/${opportunityId}/documents/download`, { path });
    return request.blob();
  };

  return {
    commitDocuments,
    searchDocuments,
    getDocuments,
    generatePresignedLink,
    downloadFileContent,
  };
};

export default useOpportunityDocumentService;
